export enum MinimizedChatDataHooks {
  ROOT = 'minimizedChat',
  BUTTON = 'minimizedChatButton',
}
